import React, { useEffect, useState } from 'react'
import { useRouter } from "next/router";


function ResponsiveSearch(props) {
    const [searchValue, setSearchValue] = useState('');
    const router = useRouter();
    const { toggleSearchIcon } = props
    useEffect(() => {
        setSearchValue("")
    }, [])

    const handleSearch = () => {
        if (searchValue.trim()) {
            router.push({
                pathname: '/search-result',
                query: { searchParam: searchValue },
            });
            setSearchValue("")
            toggleSearchIcon()
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    return (
        <div className=" w-[100vw] h-auto shadow-md flex items-end px-4 border-primary border-t-1 bg-white mb-4 transition-all duration-500 ease-[cubic-bezier(0.4, 0, 0.2, 1)]">
            <div className="w-full mb-4 ">
                <input
                    type="text"
                    placeholder="Search..."
                    className="w-full h-[63px] text-xl text-black border-b border-black pb-1 px-4 focus:outline-none  "
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <button
                    onClick={handleSearch}
                    className="absolute right-[5%] top-[55%] transform -translate-y-1/2 text-gray-500 hover:text-gray-700">
                    <svg
                        className=''
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 30 30"
                        width="30px"
                        height="30px">
                        <path
                            d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z"
                        />
                    </svg>
                </button>
            </div>
        </div>

    )
}

export default ResponsiveSearch